import { render } from "./Share.vue?vue&type=template&id=402c00d2"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=402c00d2&lang=css"
script.render = render

export default script